// src/components/ambassadors/SuccessModal.tsx
import { motion } from "framer-motion";
import { Check } from "lucide-react";

interface SuccessModalProps {
  onClose: () => void;
}

export function SuccessModal({ onClose }: SuccessModalProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.94, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.94, opacity: 0, y: 20 }}
        className="relative max-w-md w-full bg-gradient-to-br from-[#141414] to-[#1a1a1a] border border-white/10 rounded-3xl p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center">
          <div className="inline-flex p-4 bg-gradient-to-br from-amber-500 to-rose-500 rounded-full mb-6">
            <Check size={28} className="text-white" />
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-white mb-3">Application Received</h2>
          <p className="text-sm text-white/60 mb-6 leading-relaxed">
            Thank you for applying to the LRNSY Ambassador Program. We’ll review your application,
            and shortlisted creators will be contacted for the next step.
          </p>

          <button
            onClick={onClose}
            className="w-full px-4 py-3 bg-gradient-to-r from-amber-500 to-rose-500 text-white rounded-xl font-medium text-sm"
          >
            Close
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
